import PropTypes from 'prop-types';
import React from 'react';
import AbstractFilteredList from 'components/core/AbstractFilteredList';
import ListItem from 'components/core/ListItem';
import Flexbox from 'flexbox-react';
import InfoIcon from 'components/core/InfoIcon';
import SimpleMessage from 'components/core/help/SimpleMessage';
import { css, cx } from 'emotion';
import { colorTextGrey } from 'styles/base';

const dsStyle = css`
    color: ${colorTextGrey};
`;

export default class RecommendedVariablesList extends AbstractFilteredList {

    static propTypes = {
        process: PropTypes.object,
        selectable: PropTypes.bool,
        variableName: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.resetFilter();
    }

    componentWillUpdate(nextProps, nextState) {

        // if the selected dod has changed, then we need to clear the filter
        if (nextProps.datastreamName !== this.props.datastreamName) {
            this.resetFilter();
        }
    }

    resetFilter() {
        this.setLSState(
            { filter: '' },
            { update: false } // reset the local storage, but don't trigger a UI state change
        );
    }

    getItemClassName() {
        let selectableClass = '';
        if (this.props.selectable === false) {
            selectableClass = 'read-only';
        }
        return `variable-item ${selectableClass}`;
    }

    getListClassName() {
        return 'variable-list';
    }

    getListItemsClassName() {
        return 'variable-list-items';
    }

    //overriding parent's onDocumentClick so that when clicks are made outside of list selections aren't lost
    onDocumentClick = (e) => {};

    doNothing = () => {
    };

    renderItem(name, value, selected) {
        const varName = value.name;
        const dsName = value.dod;
            let onClick = this.onClick;
            if (this.props.selectable !== undefined && this.props.selectable === false) {
                onClick = this.doNothing;
            }
            return (
                <ListItem
                    key={name}
                    name={name}
                    selected={selected}
                    className={this.getItemClassName()}
                    onClick={onClick}
                    onDoubleClick={this.props.onDoubleClick}
                >
                    <Flexbox marginLeft="15px" flexDirection="row">
                        <span className="dash">&mdash;</span>
                        <InfoIcon
                            message={
                                <SimpleMessage>
                                    <p>{value.long_name}</p>
                                    <p><label>Units:</label> {value.units}</p>
                                    <p className={css`margin-bottom:0;`}><label>Dimensions:</label> ({value.dims.join(', ')})</p>
                                </SimpleMessage>
                            }
                        />
                        <strong>{varName}</strong>
                        <div className="sub-text">({dsName})</div>
                    </Flexbox>
                </ListItem>
            );

        }

}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/RecommendedVariablesList.js